// Unpublished Work © 2026 Deere & Company.

export const ALL_COUNTRIES_KEY = '__ALL_COUNTRIES__';
